const moment = require("moment");
import filter from "lodash-es/filter";
import groupBy from "lodash-es/groupBy";
import map from "lodash-es/map";
import sumBy from "lodash-es/sumBy";
import { ILogEntry } from "motw_core/Entity/ILogEntry";
import { Emotions } from "source/app/domain/Emotions/Emotions";
import { IDeepWorkKipsRecord } from "source/app/presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsChart/DeepWorkKipsChart";
import { GetMappedMonumentalRecords } from "source/app/presentation/Header/Tools/DeepWorkKipsToday/DeepWorkKipsChart/Helpers/MappedMonumentalRecord";
import { UI } from "source/app/services/UI/UI";
import { IEmotionCharacterCount } from "../../../../../../../../../motw_core/DTOs/emotioncharactercount";

export function GetMappedLogEntries(
    log: ILogEntry[],
    emotionCharacterCounts?: IEmotionCharacterCount[]
): IDeepWorkKipsRecord[] {
    const mappedMonumentalRecords = GetMappedMonumentalRecords(log);

    const rawData = log.map(
        (entry) =>
            ({
                significance: UI.GetEntrySignificance(entry.entry),
                date: moment(entry.lastmodifiedtime)
                    .local()
                    .format("YYYY-MM-DD"),
                value: entry.kips,
            } as IDeepWorkKipsRecord)
    );

    const filtered = filter(
        rawData,
        (dwkcRecord: IDeepWorkKipsRecord) =>
            dwkcRecord.value > 0 && dwkcRecord.significance === 2
    );

    const grouped = groupBy(
        filtered,
        (dwkcRecord: IDeepWorkKipsRecord) => dwkcRecord.date
    );
	
    const mapped = map(
        grouped,
        (group) =>
            ({
                significance: group[0].significance,
                value: sumBy(group, "value"),
                date: group[0].date,
                monumentalRecords: mappedMonumentalRecords.filter(
                    (mmr) => mmr.simpleDate == group[0].date
                ),
                relevantCharacterCounts: emotionCharacterCounts
                    ? emotionCharacterCounts.filter(
                          (ecc) =>
                              ecc.result_lastmodifieddate == group[0].date &&
                              Emotions.GetFromCharacter(
                                  ecc.result_value
                              ).IsAtLeast(Emotions.Peace)
                      )
                    : [],
                numLogEntries: group.length,
            } as IDeepWorkKipsRecord)
    );

    const groupedData = mapped;

    const sortedData = groupedData.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
    );

    return sortedData;
}
